import React from 'react';
import { Card, CardTitle, CardBody, CardHeader, CardFooter } from 'reactstrap';
import Info from 'src/componentes/info';

export default class CardCustom extends React.Component {
  render() {
    let {
      header,
      children,
      subtitle,
      footer,
      className,
      headerStyle,
      cardHeaderStyle = {},
      classBody = '',
      classFooter = '',
      cardWidth,
      style,
      headerContent,
      /** Conteúdo à direita do título no header (tipo checkbox, vai servit pro layout novo de configuração onde usa o configurationFIeld) */
      headerAside,
      /** Clique na linha do título para alternar checkbox da seção */
      onHeaderRowClick,
      showInfo = false,
      idInfo = 'panelHeaderInfo',
      infoText = '',
      ...rest
    } = this.props;

    return (
      <Card
        style={{ marginBottom: 15, ...style, width: cardWidth }}
        className={className}
        {...rest}
      >
        {header && (
          <CardHeader style={cardHeaderStyle}>
            {headerAside ? (
                <div
                  className="configuration-panel-header-row"
                  onClick={
                    onHeaderRowClick
                      ? (e) => {
                          if (e.target.closest('[data-tip]')) return;
                          onHeaderRowClick(e);
                        }
                      : undefined
                  }
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: '12px',
                    ...(onHeaderRowClick ? { cursor: 'pointer' } : {}),
                  }}
                >
                  <CardTitle
                    style={{
                      marginBottom: 0,
                      flex: 1,
                      minWidth: 0,
                      ...(headerStyle && headerStyle),
                    }}
                  >
                    {header}
                    {showInfo && (
                      <Info
                        id={`${idInfo}`}
                        className="ml-1"
                        placement="right"
                        text={infoText}
                      />
                    )}
                  </CardTitle>
                  {headerAside}
                </div>
              ) : (
                <CardTitle style={{ ...(headerStyle && headerStyle) }}>
                  {header}
                  {showInfo && (
                    <Info
                      id={`${idInfo}`}
                      className="ml-1"
                      placement="right"
                      text={infoText}
                    />
                  )}
                </CardTitle>
              )}
            {subtitle && (
              <h6 className="card-subtitle text-muted text-sm mt-2">
                {subtitle}
              </h6>
            )}
            {headerContent}
          </CardHeader>
        )}
        <CardBody className={classBody}>{children}</CardBody>
            {footer && <CardFooter className={classFooter}>{typeof footer === "function" ? footer() : footer}</CardFooter>}
      </Card>
    );
  }
}
